import React, { useState } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";

import { useSiteContext } from "./Providers/SSCProvider";
import { useRoleContext } from "./Providers/RoleProvider";

import InfoTP2 from "./InfoTP2";
import SingleCircuit from "./SingleCircuit";

import "./css/SiteCircuitManagement.css";
import "./css/CircuitStyle.css";
import Icon from "../generic/Icon";
import { StructureProvider } from "./Providers/StructureProvider";
import { useModalContext } from "./Providers/ModalProvider";
import DiverseModal from "./Modals/DiverseModal";
import { circuitFieldTypes } from "./Constants/circuitFieldTypes";
import RemoveCircuitModal from "./Modals/RemoveCircuitModal";

const NewStructures2 = ({ thisStructure }) => {
  const { isAdmin } = useRoleContext();
  const { openModal } = useModalContext();
  const {
    formData,
    setUpdatedCircuits,
    requiredFields,
    getFilteredCircuits,
    addCircuit,
  } = useSiteContext();
  const [showDiverseModal, setShowDiverseModal] = useState(false);
  const [cicruitModalData, setCicruitModalData] = useState({ show: false });

  const circuitFields = Object.keys(circuitFieldTypes)
    .filter((key) => isAdmin || !circuitFieldTypes[key].admin)
    .map((key) => {
      const { type, width, inlineGroup, section } = circuitFieldTypes[key];

      if (type === "diversity") {
        return { key, type, width, inlineGroup, section };
      }

      let optionsArray = [];
      if (type === "select") {
        if (key === "carrier" || key === "lec") {
          optionsArray = formData.carrier || [];
        } else if (key === "currency") {
          optionsArray = formData.iosCurrency || [];
        } else if (key === "billToCountry") {
          optionsArray = formData.countries || [];
        } else if (
          key === "accessBandwidthUnit" ||
          key === "portBandwidthUnit"
        ) {
          optionsArray = [{ name: "Mbps" }, { name: "Gbps" }];
        } else {
          optionsArray = formData[key] || [];
        }
      }

      const isObjectArray = key !== "currency" && key !== "billToCountry";
      const labelValueKey =
        key === "carrier" || key === "lec" ? "carrierName" : "name";

      return {
        key,
        placeholder: `Select ${key}`,
        options: optionsArray,
        type,
        width,
        inlineGroup,
        section,
        getOptionLabel: (o) => (isObjectArray ? o[labelValueKey] : o),
        getOptionValue: (o) => (isObjectArray ? o[labelValueKey] : o),
      };
    });

  return (
    <>
      <Card
        className="shadow-sm m-3 p-2 structure-card"
        style={{
          position: "relative",
          overflow: "hidden",
          ...(thisStructure.structureId >= 90000 && {
            border: "solid 4px orange",
          }),
        }}
      >
        <Card.Header style={{ border: "none" }} className="pt-0">
          <div
            style={{
              padding: "none",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <span>Structure {thisStructure.structureId}</span>

            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="onboarded-tooltip">Circuits In Structure</Tooltip>
              }
              offset={[0, 0.5]}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  minWidth: "24px",
                  textAlign: "center",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                }}
              >
                {thisStructure.circuits.length}
              </div>
            </OverlayTrigger>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "50%",
                width: "0.5rem",
                height: "0.5rem",
                padding: "0",
              }}
            >
              <Icon
                name="location"
                onClick={() =>
                  openModal("STRUCTURE_DATA", {
                    structureData: thisStructure,
                  })
                }
                overrides={{
                  tooltip: "View Structure Details",
                  tooltipPlacement: "top",
                  style: { fontSize: "1.2rem" },
                }}
                id="info-icon"
              />
            </div>

            {isAdmin && (
              <div
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  width: "1rem",
                  height: "1rem",
                }}
              >
                <Icon
                  name="add"
                  onClick={() => addCircuit(thisStructure.structureId)}
                  overrides={{
                    tooltip: !isAdmin
                      ? "You need admin privileges to edit"
                      : "Add Circuit",
                    tooltipPlacement: "top",
                    disabled: !isAdmin,
                    style: { fontSize: "1.2rem" },
                  }}
                  id="add-icon"
                />
              </div>
            )}
          </div>
        </Card.Header>
        <Card.Body
          className="p-0"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.03)" }}
        >
          <div className="newtp-scroll-wrapper">
            <InfoTP2 />
            <div className="newcircuit-scroll-container">
              <StructureProvider>
                {getFilteredCircuits(thisStructure).map((circuit, index) => (
                  <SingleCircuit
                    key={circuit.circuitGmId}
                    index={index}
                    initialCircuit={circuit}
                    circuitFields={circuitFields}
                    invalidFields={
                      requiredFields[thisStructure.structureId]?.[
                        circuit.circuitGmId
                      ] || []
                    }
                    setShowDiverseModal={setShowDiverseModal}
                    setCicruitModalData={setCicruitModalData}
                    onCircuitUpdated={(updated) => {
                      setUpdatedCircuits((prev) => {
                        const next = [...prev];
                        next[index] = updated;
                        return next;
                      });
                    }}
                  />
                ))}
              </StructureProvider>
            </div>
          </div>
        </Card.Body>
      </Card>
      <DiverseModal show={showDiverseModal} setShow={setShowDiverseModal} />
      <RemoveCircuitModal
        cicruitModalData={cicruitModalData}
        setCicruitModalData={setCicruitModalData}
      />
    </>
  );
};

export default NewStructures2;
